module.exports = __webpack_public_path__ + "img/intro_phone1.d49fead6.png";